import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 bg-darker relative overflow-hidden" data-id="element-64">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-accent-pink/5 pointer-events-none" data-id="element-65" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center" data-id="element-67">
          <h2 className="text-4xl md:text-6xl font-bold mb-4" data-id="element-68">
            ¿VAS A SEGUIR PERDIENDO{' '}
            <span className="text-accent-pink" data-id="element-69">TIEMPO Y PLATA?</span>
          </h2>

          <p className="text-2xl md:text-3xl text-gray-300 mb-8 font-light" data-id="element-70">
            O vas a dar el primer paso hoy.
          </p>

          <CTAButton text="QUIERO MI KIT DE SERIGRAFÍA PRO" className="scale-110" data-id="element-71" />
        </motion.div>
      </div>
    </section>;
}